import type { ArtifactMimeType } from '@onefootprint/request-types/dashboard';
import { saveAs } from 'file-saver';

type DownloadArtifactArgs = {
  contentBase64: string;
  mimeType: ArtifactMimeType;
  fileName: string;
};

const downloadArtifact = ({ contentBase64, mimeType, fileName }: DownloadArtifactArgs) => {
  // atob yields a binary string (one char code per byte); convert to a Uint8Array so
  // the Blob holds the real bytes (not UTF-16-misinterpreted text).
  let binary: string;
  try {
    binary = window.atob(contentBase64);
  } catch {
    throw new Error('Could not decode artifact content.');
  }
  const bytes = Uint8Array.from(binary, ch => ch.charCodeAt(0));
  const blob = new Blob([bytes], { type: mimeType });
  saveAs(blob, fileName);
};

export default downloadArtifact;
